<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welfarelist' }">返回</el-breadcrumb-item>
      <el-breadcrumb-item>福利发放详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="top">发福利给：
      <span>{{item.userCount}}</span>人；福利总金额
      <span>{{parseFloat(item.total).toFixed(2)}}</span>元；制表人：
      <span>{{item.name}}</span>；提交时间：
      <span>{{item.createTime.replace(/\-/g, "/").toLocaleString()}}</span>；
      审核状态：<span>{{item.status==0?'待审核':item.status==1?'通过':item.status==2?'驳回':'未知'}}</span>
      <div v-show="(item.status==1)||(item.status==2)">
        <span >审核人：{{item.handlerUserName}};</span>
        <span >审核时间：{{item.handlerTime.replace(/\-/g, "/").toLocaleString()}};</span>
        <span >审核备注：{{item.desc}};</span>
      </div>

    </div>

    <el-table :data="list">
      <el-table-column label="订单编号" prop="order_id"></el-table-column>
      <el-table-column label="发福利给" prop="realname"></el-table-column>
      <el-table-column label="福利金额（元）" prop="amount" :formatter="moenyFomat"></el-table-column>
      <el-table-column label="时间" prop="createTime">
        <template slot-scope="scope">
          {{scope.row.createTime.replace(/\-/g, "/")}}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="desc"></el-table-column>
    </el-table>
    <div class="auth" v-show="(auth==1||auth==2)&&item.status == 0">
      <el-button type="warn" @click="rejectVisible = true">驳回</el-button>
      <el-button type="success" @click="agreeVisible = true">审核通过</el-button>
    </div>
    <div class="auth" v-show="(auth!=4)&&item.status==2">
      <el-button type="primary" @click="gotoReSet">修改福利</el-button>
    </div>
    <el-dialog title="确认通过本条福利申请" :visible.sync="agreeVisible" width="30%" >
      <span slot="footer" class="dialog-footer">
        <el-button @click="agreeVisible = false">取 消</el-button>
        <el-button type="primary" @click="agree">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="驳回本条福利申请？" :visible.sync="rejectVisible" width="30%" >
      <el-input type="textarea" placeholder="请输入驳回原因(选填)" v-model="rejectStr"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectVisible = false">取 消</el-button>
        <el-button type="primary" @click="reject">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getWelfareDetailById,
  agreeWelfare,
  rejectWelfare
} from '@/api/welfare'
export default {
  data () {
    return {
      list: [],
      item: {},
      auth: '',
      agreeVisible: false,
      rejectVisible: false,
      rejectStr: '',
      companyId: ''
    }
  },
  mounted () {
    this.companyId = localStorage.companyId
    this.item = this.$route.query
    this.auth = localStorage.auth
    this.getWelfareDetail()
  },
  methods: {
    getWelfareDetail () {
      getWelfareDetailById(this.item.id).then(res => {
        this.list = res.data
      })
    },
    timeFormatter (row, col) {
      return new Date(row[col.property]).toLocaleString()
    },
    agree () {
      let data = {
        companyId: this.companyId,
        id: this.item.id
      }
      agreeWelfare(data).then(res => {
        if (res.msg === 'success') {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.agreeVisible = false
          this.$router.replace('/welfarelist')
        } else {
          this.$message({
            type: 'warn',
            message: res.msg
          })
        }
      })
    },
    reject () {
      let data = {
        companyId: this.companyId,
        desc: this.rejectStr,
        id: this.item.id
      }
      rejectWelfare(data).then(res => {
        if (res.msg === 'success') {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.rejectVisible = false
          this.$router.replace('/welfarelist')
        } else {
          this.$message({
            type: 'warn',
            message: res.msg
          })
        }
      })
    },
    moenyFomat (row, col) {
      return parseFloat(row[col.property]).toFixed(2)
    },
    gotoReSet () {
      this.store.setWelfare(this.item)
      this.store.setUsers(this.list)
      this.$router.push('/welfarereset')
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  margin: 20px;
  > span {
    color: #f30;
  }
}
.auth {
  margin: 20px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
